// extracted by mini-css-extract-plugin
module.exports = {"flagsContainer":"style_flagsContainer__3E61f","createFlagFab":"style_createFlagFab__--VwY","createLoader":"style_createLoader__2-JmT"};